"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _GatewayService = _interopRequireDefault(require("../GatewayService.js"));

var _errors = require("../errors.js");

var _log = _interopRequireDefault(require("../log.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var gradeSyncService = new _GatewayService["default"]('lms-grade-sync-svc');

var pingGradeSync = function pingGradeSync() {
  return gradeSyncService.get('liveops/ping');
};

var getGradeSyncStatus = function getGradeSyncStatus() {
  return gradeSyncService.get('liveops/status');
};

var getGradeSyncVersion = function getGradeSyncVersion() {
  return gradeSyncService.get('liveops/version');
}; // Assumes we will only be syncing one activity at a time


var postNewSync = function postNewSync(courseId, cardstackKey, cardstackTitle, maxScore, scores, teacherId, tagId, resourceDueDate) {
  if (_lodash["default"].isEmpty(courseId)) {
    _log["default"].error('Grades not synced because courseId was not specified');

    return Promise.reject((0, _errors.missingParam)('courseId'));
  }

  if (_lodash["default"].isEmpty(cardstackKey)) {
    _log["default"].error('Grades not synced because cardstackKey was not specified');

    return Promise.reject((0, _errors.missingParam)('cardstackKey'));
  }

  if (_lodash["default"].isEmpty(cardstackTitle)) {
    _log["default"].error('Grades not synced because cardstackTitle was not specified');

    return Promise.reject((0, _errors.missingParam)('cardstackTitle'));
  }

  if (_lodash["default"].isNil(maxScore)) {
    _log["default"].error('Grades not synced because maxScore was not specified');

    return Promise.reject((0, _errors.missingParam)('maxScore'));
  }

  if (_lodash["default"].isEmpty(scores)) {
    _log["default"].error('Grades not synced because no scores were given');

    return Promise.reject((0, _errors.missingParam)('scores'));
  }

  if (_lodash["default"].isEmpty(teacherId)) {
    _log["default"].error('Grades not synced because teacherId was not specified');

    return Promise.reject((0, _errors.missingParam)('teacherId'));
  }

  var body = {
    courseId: courseId,
    gradableItems: [{
      resourceId: cardstackKey,
      resourceLabel: cardstackTitle,
      maxScore: "".concat(maxScore),
      scores: scores
    }],
    initiatorUserBk: teacherId
  };
  if (tagId) body.tagId = tagId; // add resourceDueDate to the payload if it was set.
  // https://amplify-education.atlassian.net/browse/PANDA-311

  if (resourceDueDate) {
    body.gradableItems[0].resourceDueDate = resourceDueDate;
  }

  return gradeSyncService.post('v1/sync', body);
};

var cancelSyncJob = function cancelSyncJob(syncKey) {
  return gradeSyncService["delete"]("v1/sync/".concat(syncKey));
};

var getSyncJob = function getSyncJob(syncKey) {
  return gradeSyncService.get("v1/sync/".concat(syncKey));
};

var getAllSyncsForUser = function getAllSyncsForUser(userKey) {
  return gradeSyncService.get("v1/users/".concat(userKey, "/syncs"));
};

var _default = {
  pingGradeSync: pingGradeSync,
  getGradeSyncStatus: getGradeSyncStatus,
  getGradeSyncVersion: getGradeSyncVersion,
  postNewSync: postNewSync,
  cancelSyncJob: cancelSyncJob,
  getSyncJob: getSyncJob,
  getAllSyncsForUser: getAllSyncsForUser
};
exports["default"] = _default;